import FormInputText from './../Partials/FormInputText';
import FormInputTextArea2 from './../Partials/FormInputTextArea2';
import FormTagInput from './../Partials/FormTagInput';



const MetaColumn = [
    {
        field: "meta_title",
        partial: {
            handler: FormInputText,
            props: {
                initialValue: (formHandler)=> {
                    return formHandler.getArrayInputValue("meta", "meta_title");
                },
                required: false,
                label: "عنوان متا"
            }
        }
    },
    {
        field: "meta_description",
        partial: {
            handler: FormInputTextArea2,
            props: {
                initialValue: (formHandler)=> {
                    return formHandler.getArrayInputValue("meta", "meta_description");
                },
                required: false,
                label: "توضیحات متا"
            }
        }
    },
    {
        field: "keywords",
        //build list of text
        partial: {
            handler: FormTagInput,
            props: {
                initialValue: (formHandler)=> {
                    return formHandler.getArrayInputValue("meta", "keywords");
                },
                required: false,
                label: "کلمات کلیدی"
            }
        }
    },
];

export default MetaColumn;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/MetaColumn.js